import { useOrgBranding } from '@/hooks/use-org-branding'
import { cn } from '@/lib/utils'
import { useAuthStore } from '@/stores/auth.store'
import { Clock, Home, LogOut, Upload, Users } from 'lucide-react'
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom'

const portalNavItems = [
  {
    name: 'Dashboard',
    href: '/dashboard',
    icon: Home,
  },
  {
    name: 'People',
    href: '/people',
    icon: Users,
  },
  {
    name: 'Import',
    href: '/import',
    icon: Upload,
  },
  {
    name: 'Import History',
    href: '/imports',
    icon: Clock,
  },
]

export function PortalLayout() {
  const location = useLocation()
  const navigate = useNavigate()
  const { orgName, logoUrl } = useOrgBranding()
  const { clearAuth, user } = useAuthStore()

  const handleLogout = () => {
    clearAuth()
    navigate('/login')
  }

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <aside className="w-64 border-r bg-white flex flex-col">
        <div className="px-5 py-5 border-b">
          {logoUrl ? (
            <img
              src={logoUrl}
              alt={orgName || ''}
              className="h-8 w-auto max-w-[160px] object-contain"
            />
          ) : (
            <span className="text-lg font-semibold tracking-tight text-foreground">
              {orgName || 'Portal'}
            </span>
          )}
        </div>
        <nav className="flex flex-col gap-0.5 px-3 py-4 flex-1">
          {portalNavItems.map((item) => {
            const Icon = item.icon
            const isActive = location.pathname === item.href

            return (
              <Link
                key={item.href}
                to={item.href}
                className={cn(
                  'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-blue-600 text-white'
                    : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900',
                )}
              >
                <Icon className="h-4 w-4" />
                {item.name}
              </Link>
            )
          })}
        </nav>
        <div className="border-t px-3 py-3">
          {user && (
            <div className="flex items-center justify-between px-3 py-2">
              <div className="min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">
                  {user.full_name || user.first_name || user.email}
                </p>
                {user.email && <p className="text-xs text-gray-500 truncate">{user.email}</p>}
              </div>
              <button
                type="button"
                onClick={handleLogout}
                className="ml-2 p-1.5 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                title="Sign out"
              >
                <LogOut className="h-4 w-4" />
              </button>
            </div>
          )}
          <div className="flex items-center gap-1.5 px-3 pt-2 text-[11px] text-gray-400">
            <span>Powered by Pelgo</span>
          </div>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-auto bg-gray-50">
        <Outlet />
      </main>
    </div>
  )
}
